import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "wrapper"
}
const _hoisted_2 = { class: "title text-center" }
const _hoisted_3 = { key: 0 }

import ChatFormButton from "~/chat/vue/widget/form/fields/ChatFormButton.vue";
import TabMessageWrapper from "~/chat/ts/data/chat/TabMessageWrapper";
import {useMessageTypeProps} from "~/chat/vue/widget/tabs/chat/useMessageType";
import {computed} from "vue";
import {__} from "~/ts/library/Translate";


const __default__ = {
    name: "ChatMessageTypeTab"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    ...useMessageTypeProps()
},
  setup(__props) {

let props = __props;

let tab = computed(() => {
    return tabWrapper.value.tab;
});

let tabWrapper = computed(() => {
    return new TabMessageWrapper(props.message.rawMessage);
});


function onClick() {
    tabWrapper.value.openTab();
}

return (_ctx: any,_cache: any) => {
  return (_unref(tab))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(tab).title), 1),
        _createVNode(ChatFormButton, {
          type: "primary w-100 d-block",
          onClick: onClick
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(__)("Открыть")), 1)
          ]),
          _: 1
        }),
        (_ctx.$slots.reactions)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "reactions")
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})